import Tokarny_Stanok from "../../../../common/assets/images/Montronix/Video/токарный станок.jpg";
import Frezer_Stanok from "../../../../common/assets/images/Montronix/Video/Фрезерный станок.jpg";
import Wear_Trendl from "../../../../common/assets/images/Montronix/Video/Wear Trend.png";
import Wifi_Page_5_1 from "../../../../common/assets/images/Montronix/Video/ГОСТ ИСО 10816-3-2002 Color.svg";
import Wifi_Page_8_1 from "../../../../common/assets/images/Montronix/Video/Wifi_Page_8_1.png";
import Wifi_Page_8_2 from "../../../../common/assets/images/Montronix/Video/Wifi_Page_8_2.png";
import Wifi_Page_8_3 from "../../../../common/assets/images/Montronix/Video/Wifi_Page_8_3.png";
import Wifi_Page_8_4 from "../../../../common/assets/images/Montronix/Video/Wifi_Page_8_4.png";
import Wifi_Page_2_1 from "../../../../common/assets/images/Montronix/Video/Wifi_Page_2_1.jpg";
import Wifi_Page_4_1 from "../../../../common/assets/images/Montronix/Video/WiFI_4_1.png";
import Wifi_Page_4_2 from "../../../../common/assets/images/Montronix/Video/WiFI_4_2.png";


import { Ipoint2D } from "../../../../common/interfaces";

export const videoPointsWIFI: Ipoint2D[] = [
  {
    id: 1,
    top: "0.5rem",
    left: "54%",
    title: "Решаемые задачи",
    title_short: "Решаемые задачи",
    content: [""],
    text: [""],
    titletext:[""],
    list: [
      {
        title: "",
        quotes: [
          "Экспресс диагностика узлов и механизмов станочного оборудования.",
          "Определение зарождающихся дефектов на ранних стадиях.",
          "Прогнозирование выхода из строя оборудования.",
          "Ведение гибкой системы технического контроля оборудования \n путем анализа тренда развития износа оборудования.",
        ],
      },
    ],
  },
  {
    id: 2,
    top: "0.5rem",
    left: "40%",
    title: "WiFi BoxNG – Установка на оборудование ",
    title_short: "Установка WiFi BoxNG",
    content: [Wifi_Page_2_1],
    titletext:[""],
    text: [
      "Мобильная система диагностики Montronix представляет из себя комплект, состоящий из З-осевого датчика контроля вибрации PulseNG, устанавливаемого на рабочий узел станка для снятия необходимых показателей его состояния, и приемника-преобразователя со встроенным WiFi модулем для беспроводной передачи сигналов, а также ПК для отслеживания вибрации..",
    ],
  },
  {
    id: 3,
    top: "0.5rem",
    left: "47%",
    title: "Выбор места крепления для установки датчика",
    title_short: "Место крепления",
    content: [Tokarny_Stanok,Frezer_Stanok],
    titletext:[""],
    text: ["Токарный станок","Фрезерный станок"],
  },
  {
    id: 4,
    top: "0.5rem",
    left: "54%",
    title: "Диагностируемые узлы",
    titletext:[""],
    title_short: "Диагностируемые узлы",
    content: [Wifi_Page_4_2,Wifi_Page_4_1],
    text: ["Использование WiFi BOX позволяет выявить ошибки в настройке измерительных систем и работе сервоприводов станка, проводить оценку качества ремонтных работ, анализируя параметры вибрации до и после ремонта.","Проведение оперативной диагностики узлов и механизмов станка, позволяет выявить износ, люфты и другие дефекты на ранней стадии развития."],
  },
  {
    id: 5,
    top: "0.5rem",
    left: "54%",
    title: "Нормирование вибрации ШУ и двигателей",
    title_short: "Нормирование вибрации",
    content: [""],
    text: [""],
    titletext:[""],
    minWidthTable:"60vw",
    maxWidthTable:"60vw",
    table: {
      tableheads: [
        { width: "100%", content: "Классификация ШУ" },
      ],
      rows: [
        {
          tableText:["Промышленные машины номинальной мощностью более 15 кВт и номинальной скоростью от 120 до 1500 мин в ст. минус 1"],
          tableContent:[
            Wifi_Page_5_1
          ],
          title: "ГОСТ ИСО 10816",
          showhead: false,
          columns: [
            [{content:["Vскз, мм/с"],color:["white"],borderLeft:[""],borderRIght:[""],borderButton:[""],borderTop:[""],paddingRight:[""],},
            {content:["Кл. 1"],color:["white"],borderRIght:["1vh solid #fff"],borderButton:[""],borderTop:[""],borderLeft:[""]},
            {content:["Кл. 2"],color:["white"],borderRIght:["1vh solid #fff"],borderButton:[""],borderTop:[""],borderLeft:[""]},
            {content:["Кл. 3"],color:["white"],borderRIght:["1vh solid #fff"],borderButton:[""],borderTop:[""]},
            {content:["Кл. 4"],color:["white"],borderRIght:[""],borderButton:[""],borderTop:[""]}],

            [{content:["45"],color:["white"],borderRIght:["0"],borderTop:[""],borderLeft:[""],borderButton:[""]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"],borderLeft:[""],borderTop:[""],borderButton:[""]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"],borderLeft:[""],borderTop:[""],borderButton:[""]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"],borderLeft:[""],borderTop:[""],borderButton:[""]},
            {content:["D"],color:["#FF652F"],colorValue:["white"],borderRIght:[""],borderTop:[""],borderButton:[""]}],

            [{content:["28"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"]},
            {content:["D"],color:["#FF652F"],colorValue:["white"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#FF652F"]}],

            [{content:["18"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:["D"],color:["#FF652F"],colorValue:["white"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"]},
            {content:["C"],color:["#FFE400"],colorValue:["black"],colorChange:[true]}],

            [{content:["11,2"],color:["white"],borderButton:[""],borderTop:[""],borderRIght:[""]},
            {content:["D"],color:["#FF652F"],colorValue:["white"],borderRIght:["1vh solid #fff"],borderButton:[""],borderTop:[""]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"],borderButton:[""],borderTop:[""]},
            {content:["C"],color:["#FFE400"],colorValue:["black"],colorChange:[true],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:[" "],color:["#FFE400"],borderButton:[""],borderTop:[""]}],

            [{content:["7,1"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:[" "],color:["#FF652F"],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:["C"],color:["#FFE400"],colorValue:["black"],colorChange:[true],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#FFE400"],borderRIght:["1vh solid #fff"]},
            {content:["B"],color:["#14A76C"],colorValue:["black"],colorChange:[true]}],

            [{content:["4,5"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:["C"],color:["#FFE400"],colorValue:["black"],colorChange:[true],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:[" "],color:["#FFE400"],borderRIght:["1vh solid #fff"]},
            {content:["B"],color:["#14A76C"],colorValue:["black"],colorChange:[true],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#14A76C"]}],

            [{content:["2,8"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:[" "],color:["#FFE400"],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:["B"],color:["#14A76C"],colorValue:["black"],colorChange:[true],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#14A76C"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"],colorChange:[true]}],

            [{content:["1,8"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:["B"],color:["#14A76C"],colorValue:["black"],colorChange:[true],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:[" "],color:["#14A76C"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"],colorChange:[true],borderRIght:["1vh solid #fff"]},
            {content:["A"],color:["#3F3CFF"],colorValue:["white"]}],

            [{content:["1,12"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:[" "],color:["#14A76C"],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:[" "],color:["#3F3CFF"],colorChange:[true],borderRIght:["1vh solid #fff"]},
            {content:["A"],color:["#3F3CFF"],colorValue:["white"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"]}],

            [{content:["0,71"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:[" "],color:["#3F3CFF"],colorChange:[true],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:["A"],color:["#3F3CFF"],colorValue:["white"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"]}],

            [{content:["0,45"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:["A"],color:["#3F3CFF"],colorValue:["white"],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:[" "],color:["#3F3CFF"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"]}],

            [{content:["0,28"],color:["white"],borderButton:[""],borderRIght:[""]},
            {content:[" "],color:["#3F3CFF"],borderRIght:["1vh solid #fff"],borderButton:[""]},
            {content:[" "],color:["#3F3CFF"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"],borderRIght:["1vh solid #fff"]},
            {content:[" "],color:["#3F3CFF"]}],

            
            
          ],
        },
        {
          tableText:["Нормирование мотор шпинделей по ISO/TR 17243-1:2014"],
          tableContent:[""],
          title: "ISO/TR 17243-1:2014",
          showhead: false,
          columns: [
           

            [
              {content:[""],color:["rgb(193, 208, 238)"],paddingRight:[""],borderButton:[""]},
              {content:[""],color:["rgb(193, 208, 238)"],borderLeft:["1vh solid #fff"],borderRIght:[""],borderButton:[""]},
              {content:[""],color:["rgb(193, 208, 238)"],borderRIght:["1vh solid rgb(193, 208, 238)"],borderLeft:["1vh solid #fff"]},

            {content:["Классификация ШУ"],color:["rgb(193, 208, 238)"],borderRIght:["1vh solid rgb(193, 208, 238)"]},
            {content:[" "],color:["rgb(193, 208, 238)"],borderRIght:["1vh solid rgb(193, 208, 238)"]},
            {content:[" "],color:["rgb(193, 208, 238)"]},
            ],

            [{content:["Границы зон"],color:["rgb(193, 208, 238)"],paddingRight:[""],colorValue:["black"],borderTop:[""]},
            {content:["Значение"],color:["rgb(193, 208, 238)"],borderLeft:["1vh solid #fff"],colorValue:["black"],borderRIght:[""],borderTop:[""]},
            {content:["≤5кВт шариковый подшипник"],borderLeft:["1vh solid #fff"],borderRIght:["1vh solid #fff"],color:["rgb(193, 208, 238)"],colorValue:["black"],borderTop:["1vh solid #fff"]},
            {content:[">5кВт шариковый подшипник"],borderRIght:["1vh solid #fff"],color:["rgb(193, 208, 238)"],colorValue:["black"],borderTop:["1vh solid #fff"]},
            {content:["≤5 кВт роликовый подшипник"],borderRIght:["1vh solid #fff"],color:["rgb(193, 208, 238)"],colorValue:["black"],borderTop:["1vh solid #fff"]},
            {content:[">5 кВт роликовый подшипник"],color:["rgb(193, 208, 238)"],colorValue:["black"],borderTop:["1vh solid #fff"]}],

            [{content:["a"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["0,7"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["0,7"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["0,7"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["0,7"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["b"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["мм/с, ср.кв."],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["1,1"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["1,4"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["1,1"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["1,4"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["c"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:[""],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:["1,8"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:["2,8"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:["1,8"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:["2,8"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]}],

            [{content:["i"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:["6"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:["6"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:["8"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:["8"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]}],

            [{content:["ii"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["10"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["10"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["13"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["13"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["iii"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["15"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["15"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["20"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["20"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["iv"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["м/с², ср.кв."],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["20"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["20"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["26"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["26"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["v"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["25"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["25"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["32"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["32"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["vi"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["30"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["30"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["39"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["39"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["vii"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["40"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["40"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["52"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["52"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["viii"],color:["WHITE"],colorValue:["black"]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["50"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["50"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["65"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["65"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

          
            
          ],
        },
        {
          tableText:["Нормирование  шпинделей с прямым и ременным приводом по ISO/TR 17243-2:2017"],
          tableContent:[""],
          title: "ISO/TR 17243-2:2017",
          showhead: false,
          columns: [
           

            [
              {content:[""],color:["rgb(193, 208, 238)"],paddingRight:[""],borderButton:[""]},
              {content:[""],color:["rgb(193, 208, 238)"],borderLeft:["1vh solid #fff"],borderRIght:[""],borderButton:[""]},
              {content:[""],color:["rgb(193, 208, 238)"],borderRIght:["1vh solid rgb(193, 208, 238)"],borderLeft:["1vh solid #fff"]},

            {content:["Классификация ШУ"],color:["rgb(193, 208, 238)"],borderButton:[""],borderRIght:["1vh solid rgb(193, 208, 238)"]},
            {content:[" "],color:["rgb(193, 208, 238)"],borderButton:[""],borderRIght:["1vh solid rgb(193, 208, 238)"]},
            {content:[" "],color:["rgb(193, 208, 238)"],borderButton:[""]},
            ],

            [{content:["Границы зон"],color:["rgb(193, 208, 238)"],paddingRight:[""],colorValue:["black"],borderTop:[""]},
            {content:["Значение"],color:["rgb(193, 208, 238)"],borderLeft:["1vh solid #fff"],colorValue:["black"],borderRIght:[""],borderTop:[""]},
            {content:["≤5кВт шариковый подшипник"],borderLeft:["1vh solid #fff"],borderRIght:["1vh solid #fff"],color:["rgb(193, 208, 238)"],colorValue:["black"],borderTop:["1vh solid #fff"]},
            {content:[">5кВт шариковый подшипник"],borderRIght:["1vh solid #fff"],color:["rgb(193, 208, 238)"],colorValue:["black"],borderTop:["1vh solid #fff"]},
            {content:["≤5 кВт роликовый подшипник"],borderRIght:["1vh solid #fff"],color:["rgb(193, 208, 238)"],colorValue:["black"],borderTop:["1vh solid #fff"]},
            {content:[">5 кВт роликовый подшипник"],color:["rgb(193, 208, 238)"],colorValue:["black"],borderTop:["1vh solid #fff"]}],

            [{content:["a"],color:["WHITE"],colorValue:["black"],border:[""],padding:[""],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],border:[""],padding:[""],borderRIght:[""]},
            {content:["0,9"],color:["WHITE"],colorValue:["black"],border:[""],padding:[""],borderRIght:[""]},
            {content:["0,9"],color:["WHITE"],colorValue:["black"],border:[""],padding:[""],borderRIght:[""]},
            {content:["0,9"],color:["WHITE"],colorValue:["black"],border:[""],padding:[""],borderRIght:[""]},
            {content:["0,9"],color:["WHITE"],colorValue:["black"],border:[""],padding:[""],borderRIght:[""]}],

            [{content:["b"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["мм/с, ср.кв."],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["1,4"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["1,8"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["1,4"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["1,8"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["c"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:[""],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:["2,3"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:["3,6"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:["2,3"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]},
            {content:["3,6"],color:["WHITE"],colorValue:["black"],borderButton:["0.3vh solid rgb(193, 208, 238)"],borderRIght:[""]}],

            [{content:["i"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:["6"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:["6"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:["8"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]},
            {content:["8"],color:["WHITE"],colorValue:["black"],borderTop:[""],borderRIght:[""]}],

            [{content:["ii"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["10"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["10"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["13"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["13"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["iii"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["15"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["15"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["20"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["20"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["iv"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["м/с², ср.кв."],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["20"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["20"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["26"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["26"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["v"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["25"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["25"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["32"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["32"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["vi"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["30"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["30"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["39"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["39"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["vii"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["40"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["40"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["52"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["52"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

            [{content:["viii"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:[" "],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["50"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["50"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["65"],color:["WHITE"],colorValue:["black"],borderRIght:[""]},
            {content:["65"],color:["WHITE"],colorValue:["black"],borderRIght:[""]}],

          
            
          ],
        },
      ],
    },
  },
  {
    id: 6,
    top: "0.5rem",
    left: "54%",
    title: "Тренд износа ШУ",
    title_short: "Тренд износа ШУ ",
    content: [Wear_Trendl],
    text: [""],
    titletext:[""],
    
  },
  {
    id: 7,
    top: "0.5rem",
    left: "54%",
    title: "Экономические выгоды",
    title_short: "Экономические выгоды",
    content: [""],
    text: [""],
    titletext:[""],
    list: [
      {
        title: "",
        quotes: [
          "Сокращение времени на поиск и устранение неполадок.",
          "Экономия времени обслуживающего станок персонала.",
          "Минимизация выходов из строя и простоя оборудования.",
          "Экономия расходов на ремонт и обслуживание станков.",
        ],
      },
    ],
    
   
  },
  {
    id: 8,
    top: "0.5rem",
    left: "54%",
    title: "Типовые дефекты",
    title_short: "Типовые дефекты",
    content: [Wifi_Page_8_1,Wifi_Page_8_4,Wifi_Page_8_2,Wifi_Page_8_3],
    titletext:["Дефект ходового винта","Пульсация шпинделя-дисбаланс","Дефект винтовых канавок гайки ШВП","Дефект поворотной оси"],
    text: [
      "График вибраций с одинаковой амплитудой по всем трем осям при прямолинейном движении, вызванная циклическим биением шарика о поверхность винта вследствие его износа,  свидетельствует о дефекте ходового винта  ШВП.",
      "Постоянная вибрация не выходящая за пределы допустимых значений зачастую связана с проблемами внешних элементов ШУ: оправками, цангами, инструментом, вызывающие дисбаланс инструментальной сборки.",
      "Если амплитуда вибрации по двум осям существенно выше чем по третьей,  это свидетельствует о вероятном износе одной или нескольких винтовых канавок гайки ШВП.",
      "Повышенная вибрация при повороте стола в обратном направлении в сравнении с движением в прямом,  свидетельствует о неисправности привода движения или ошибках измерительной системы."    ],
  },
  {
    id: 9,
    top: "0.5rem",
    left: "54%",
    titletext:[""],
    title: "Технические характеристики WiFi BOX NG",
    title_short: "Технические характеристики ",
    minWidthTable:"600px",
    maxWidthTable:"600px",
    content: [""],
    text: [""],
    table: {
      tableheads: [
        { width: "100%", content: "Классификация ШУ" },
      ],
      rows: [
        {
          tableText:[""],
          tableContent:[
            ""
          ],
          title: "3-x осевой датчик вибрации Pulse NG          ",
          showhead: false,
          columns: [
            [{content:["Размеры (ШxВxГ в мм)"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["30 x 40 x 12"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Корпус"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Литой алюминиевый"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Вес"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["100 грамм"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Степень защиты"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["IP67"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Температурные ограничения"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Эксплуатация 0 до 70°C, Хранение -40 до 70°C"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Относительная влажность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["От 0 до 100 %"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Соединение"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["PUR кабель M8 c 4 пинами"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Длина кабеля"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["2 метра, может быть увеличен до 100 метров"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Диаметр кабеля"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["4,9 мм"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Тип датчика"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["МЕМС"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Диапазон измерения"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["± 60 м/с² (± 6 g)"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Линейность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["0.1 % F.S."],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Интерфейс"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["< 2 %"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Ширина полосы пропускания"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["1.6 кГц"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Разрешение"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["0,025 м/с² @ 100 Hz"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Ударопрочность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["9810 м/с²"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],

            [{content:["Датчик температуры"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:[""],borderTop:[""]},
            {content:["От 0 до 70°C, абсолют погрешность 1°"],color:["white"],borderRIght:[""],borderButton:[""],borderTop:[""]},
            ],



            
            
          ],
        },
        {
          tableText:[""],
          tableContent:[""],
          title: "WiFi BoxNG",
          showhead: false,
          columns: [
            [{content:["Размеры (ВxШxГ в мм)"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["130 x 85 x 35"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Корпус"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Литой алюминиевый"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Вес"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Примерно 450 г."],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Класс защиты"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["IP54"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Температурный диапазон"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Использование от 0 до 50°C хранение от -20 до 70°C"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Относительная влажность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["От 0 до 95% без конденсата"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Напряжение питания"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["12 - 28 В DC"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Потребляемый ток заряда при 12 В / 24 В"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["1000 mA / 2000mA макс."],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Стандарт"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["IEEE 802.11 b/g/n"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Защита"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["WPA2 , 256-bit AES шифрование"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Сетевые возможности"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Точка доступа с сервером DHCP"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Диапазон приема"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["до 100 м. в помещении"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Нормы"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["EN 60950-1, EN 301489-3"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Частотный диапазон"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["2,412 - 2,484 гГц"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Номинальная мощность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["14 дБм +11,5 дБм -1,0 дБм"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Максимальный прием"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["-10 дБм (с PER <8%)"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Модуляция"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["OFDM, DSSS, CCK, DQPSK,\n DBPSK, 64 QAM, 16 QAM"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Время работы от батареи"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["~ 15 ч"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Время для полного заряда"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:[""],borderTop:[""]},
            {content:["~ 2 ч"],color:["white"],borderRIght:[""],borderButton:[""],borderTop:[""]},
            ],
          
            
          ],
        },
      ],
    },
  }
];